import { QueryClient, QueryClientProvider, setLogger } from 'react-query';
import * as Sentry from '@sentry/react';
import Home from '@pages/home';
import { ThemeProvider } from '@styles/global';

function App() {
  if (window.location.pathname === '/status') {
    return <h1>success</h1>;
  }

  const queryClient = new QueryClient();

  setLogger({
    log: message => console.log(message), // eslint-disable-line no-console
    warn: message => console.warn(message), // eslint-disable-line no-console
    error: error => Sentry.captureException(error),
  });

  return (
    <Sentry.ErrorBoundary
      showDialog
      fallback={<p>An error has occurred</p>}
    >
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <Home />
        </ThemeProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
